import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  label: {
    color: '#0F0F0F',
    fontFamily: '"Readex Pro"',
    fontSize: 14,
    fontWeight: 200,
    lineHeight: '20px',
    letterSpacing: '0.56px',
  },
  require: {
    marginLeft: 6,
    color: Colors.Red6,
    fontSize: 18,
    fontWeight: 500,
  },
  decimalInputStyle: {
    '& .MuiInputBase-input': {
      height: 'unset',
      padding: '12px 8px',
      fontSize: 14,
      lineHeight: 1.42858,
    },
  },
  flexItem: {
    flex: 1,
  },
  lineSeparate: {
    marginLeft: 8,
    marginRight: 8,
    transform: 'translateY(10px)',
  },
}));

export default useStyles;
